module.exports = __webpack_public_path__ + "img/title-two.26b8863b.png";